import {fetchApiDataV2, getVvLink } from "../../utils/utils"

export const getShowsByCategory = async (appInfo, key)=>{
    const api=key?`smartHome/${key}`:`home`;
    const params = getVvLink() ? { vv_link: getVvLink() } : {};
    return await fetchApiDataV2(appInfo,api,params)
}

